import {
  FaCode,
  FaGlobe,
  FaMobileAlt,
  FaPalette,
  FaCloud,
  FaShoppingCart,
  FaServer,
  FaSearch,
  FaBullhorn,
  FaAndroid,
  FaApple,
  FaReact,
  FaTools,
  FaCogs,
  FaEdit,
  FaRedo,
} from "react-icons/fa";

const servicesData = [
  {
    id: 1,
    icon: <FaCode />,
    title: "Custom Software Development",
    description:
      "Tailored enterprise-grade software solutions designed to solve complex business challenges with scalability and performance in mind.",
    link: "/start-project#start-project-form",
  },
  {
    id: 2,
    icon: <FaGlobe />,
    title: "Web Application Development",
    description:
      "High-performance, secure, and scalable web applications built using modern technologies and clean architecture.",
    link: "/start-project#start-project-form",
  },
  {
    id: 3,
    icon: <FaMobileAlt />,
    title: "Web & Mobile Applications",
    description:
      "Cross-platform applications delivering seamless experiences across web and mobile devices.",
    link: "/start-project#start-project-form",
  },
  {
    id: 4,
    icon: <FaCloud />,
    title: "Cloud Services & DevOps",
    description:
      "Scalable cloud architecture, migration, and DevOps consulting to ensure reliability and performance.",
    link: "/start-project#start-project-form",
  },
  {
    id: 5,
    icon: <FaPalette />,
    title: "Design & UI/UX",
    description:
      "Modern, user-focused digital experiences designed to maximize usability, engagement, and conversions.",
    link: "/start-project#start-project-form",
  },
  {
    id: 6,
    icon: <FaShoppingCart />,
    title: "E-Commerce Solutions",
    description:
      "Secure, scalable online stores with seamless payment, inventory, and order management.",
    link: "/start-project#start-project-form",
  },
  {
    id: 7,
    icon: <FaServer />,
    title: "API Development & Integrations",
    description:
      "Robust system APIs and third-party integrations for seamless data exchange and automation.",
    link: "/start-project#start-project-form",
  },
  {
    id: 8,
    icon: <FaSearch />,
    title: "Search Engine Optimization (SEO)",
    description:
      "Improve online visibility, rankings, and organic traffic with data-driven SEO strategies.",
    link: "/start-project#start-project-form",
  },
  {
    id: 9,
    icon: <FaBullhorn />,
    title: "Digital Marketing",
    description:
      "Performance-driven digital marketing solutions including PPC, social media, and growth campaigns.",
    link: "/start-project#start-project-form",
  },
  {
    id: 10,
    icon: <FaAndroid />,
    title: "Android App Development",
    description:
      "Custom Android applications built for performance, security, and long-term scalability.",
    link: "/start-project#start-project-form",
  },
  {
    id: 11,
    icon: <FaApple />,
    title: "iOS Application Development",
    description:
      "Premium iOS applications designed for performance, stability, and exceptional user experience.",
    link: "/start-project#start-project-form",
  },
  {
    id: 12,
    icon: <FaReact />,
    title: "React JS Applications",
    description:
      "Modern, fast, and scalable frontend applications built with React and best practices.",
    link: "/start-project#start-project-form",
  },
  {
    id: 13,
    icon: <FaMobileAlt />,
    title: "React Native Applications",
    description:
      "Cross-platform mobile applications with native performance using React Native.",
    link: "/start-project#start-project-form",
  },
  {
    id: 14,
    icon: <FaEdit />,
    title: "Website Designing",
    description:
      "Creative, responsive website designs that reflect your brand and convert users.",
    link: "/start-project#start-project-form",
  },
  {
    id: 15,
    icon: <FaRedo />,
    title: "Website Redesigning",
    description:
      "Modernize and revamp existing websites to improve performance, UX, and conversions.",
    link: "/start-project#start-project-form",
  },
  {
    id: 16,
    icon: <FaTools />,
    title: "Application Maintenance & Support",
    description:
      "Ongoing application support, performance optimization, and system maintenance.",
    link: "/start-project#start-project-form",
  },
  {
    id: 17,
    icon: <FaCogs />,
    title: "CMS Applications",
    description:
      "Flexible content management solutions for easy updates, scalability, and control.",
    link: "/start-project#start-project-form",
  },
];

export default servicesData;
